// src/config/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { migrateToFrenchDefault } from '../utils/languageMigration';

// AUTO-GENERATED imports — run: node scripts/generate-i18n-config.mjs
import enAcaced from '../locales/en/acaced.json';
import enAccounting from '../locales/en/accounting.json';
import enAccueil from '../locales/en/accueil.json';
import enAssociation from '../locales/en/association.json';
import enBilling from '../locales/en/billing.json';
import enBoarding from '../locales/en/boarding.json';
import enCalendar from '../locales/en/calendar.json';
import enClientsDogs from '../locales/en/clientsdogs.json';
import enCommon from '../locales/en/common.json';
import enEvents from '../locales/en/events.json';
import enLegal from '../locales/en/legal.json';
import enLegalMentions from '../locales/en/legalMentions.json';
import enLogin from '../locales/en/login.json';
import enMarketing from '../locales/en/marketing.json';
import enMarketingTools from '../locales/en/marketingTools.json';
import enMessaging from '../locales/en/messaging.json';
import enNavigation from '../locales/en/navigation.json';
import enNotes from '../locales/en/notes.json';
import enPackages from '../locales/en/packages.json';
import enPlanning from '../locales/en/planning.json';
import enProfile from '../locales/en/profile.json';
import enQuotes from '../locales/en/quotes.json';
import enRegistration from '../locales/en/registration.json';
import enReservations from '../locales/en/reservations.json';
import enServices from '../locales/en/services.json';
import enSettings from '../locales/en/settings.json';
import enSidebar from '../locales/en/sidebar.json';
import enStatistics from '../locales/en/statistics.json';
import enSubscription from '../locales/en/subscription.json';
import enWhatsNew from '../locales/en/whatsNew.json';
import frAcaced from '../locales/fr/acaced.json';
import frAccounting from '../locales/fr/accounting.json';
import frAccueil from '../locales/fr/accueil.json';
import frAssociation from '../locales/fr/association.json';
import frBilling from '../locales/fr/billing.json';
import frBoarding from '../locales/fr/boarding.json';
import frCalendar from '../locales/fr/calendar.json';
import frClientsDogs from '../locales/fr/clientsdogs.json';
import frCommon from '../locales/fr/common.json';
import frEvents from '../locales/fr/events.json';
import frLegal from '../locales/fr/legal.json';
import frLegalMentions from '../locales/fr/legalMentions.json';
import frLogin from '../locales/fr/login.json';
import frMarketing from '../locales/fr/marketing.json';
import frMarketingTools from '../locales/fr/marketingTools.json';
import frMessaging from '../locales/fr/messaging.json';
import frNavigation from '../locales/fr/navigation.json';
import frNotes from '../locales/fr/notes.json';
import frPackages from '../locales/fr/packages.json';
import frPlanning from '../locales/fr/planning.json';
import frProfile from '../locales/fr/profile.json';
import frQuotes from '../locales/fr/quotes.json';
import frRegistration from '../locales/fr/registration.json';
import frReservations from '../locales/fr/reservations.json';
import frServices from '../locales/fr/services.json';
import frSettings from '../locales/fr/settings.json';
import frSidebar from '../locales/fr/sidebar.json';
import frStatistics from '../locales/fr/statistics.json';
import frSubscription from '../locales/fr/subscription.json';
import frWhatsNew from '../locales/fr/whatsNew.json';
import esAcaced from '../locales/es/acaced.json';
import esAccounting from '../locales/es/accounting.json';
import esAccueil from '../locales/es/accueil.json';
import esAssociation from '../locales/es/association.json';
import esBilling from '../locales/es/billing.json';
import esBoarding from '../locales/es/boarding.json';
import esCalendar from '../locales/es/calendar.json';
import esClientsDogs from '../locales/es/clientsdogs.json';
import esCommon from '../locales/es/common.json';
import esEvents from '../locales/es/events.json';
import esLegal from '../locales/es/legal.json';
import esLegalMentions from '../locales/es/legalMentions.json';
import esLogin from '../locales/es/login.json';
import esMarketing from '../locales/es/marketing.json';
import esMarketingTools from '../locales/es/marketingTools.json';
import esMessaging from '../locales/es/messaging.json';
import esNavigation from '../locales/es/navigation.json';
import esNotes from '../locales/es/notes.json';
import esPackages from '../locales/es/packages.json';
import esPlanning from '../locales/es/planning.json';
import esProfile from '../locales/es/profile.json';
import esQuotes from '../locales/es/quotes.json';
import esRegistration from '../locales/es/registration.json';
import esReservations from '../locales/es/reservations.json';
import esServices from '../locales/es/services.json';
import esSettings from '../locales/es/settings.json';
import esSidebar from '../locales/es/sidebar.json';
import esStatistics from '../locales/es/statistics.json';
import esSubscription from '../locales/es/subscription.json';
import esWhatsNew from '../locales/es/whatsNew.json';
import deAcaced from '../locales/de/acaced.json';
import deAccounting from '../locales/de/accounting.json';
import deAccueil from '../locales/de/accueil.json';
import deAssociation from '../locales/de/association.json';
import deBilling from '../locales/de/billing.json';
import deBoarding from '../locales/de/boarding.json';
import deCalendar from '../locales/de/calendar.json';
import deClientsDogs from '../locales/de/clientsdogs.json';
import deCommon from '../locales/de/common.json';
import deEvents from '../locales/de/events.json';
import deLegal from '../locales/de/legal.json';
import deLegalMentions from '../locales/de/legalMentions.json';
import deLogin from '../locales/de/login.json';
import deMarketing from '../locales/de/marketing.json';
import deMarketingTools from '../locales/de/marketingTools.json';
import deMessaging from '../locales/de/messaging.json';
import deNavigation from '../locales/de/navigation.json';
import deNotes from '../locales/de/notes.json';
import dePackages from '../locales/de/packages.json';
import dePlanning from '../locales/de/planning.json';
import deProfile from '../locales/de/profile.json';
import deQuotes from '../locales/de/quotes.json';
import deRegistration from '../locales/de/registration.json';
import deReservations from '../locales/de/reservations.json';
import deServices from '../locales/de/services.json';
import deSettings from '../locales/de/settings.json';
import deSidebar from '../locales/de/sidebar.json';
import deStatistics from '../locales/de/statistics.json';
import deSubscription from '../locales/de/subscription.json';
import deWhatsNew from '../locales/de/whatsNew.json';
import itAcaced from '../locales/it/acaced.json';
import itAccounting from '../locales/it/accounting.json';
import itAccueil from '../locales/it/accueil.json';
import itAssociation from '../locales/it/association.json';
import itBilling from '../locales/it/billing.json';
import itBoarding from '../locales/it/boarding.json';
import itCalendar from '../locales/it/calendar.json';
import itClientsDogs from '../locales/it/clientsdogs.json';
import itCommon from '../locales/it/common.json';
import itEvents from '../locales/it/events.json';
import itLegal from '../locales/it/legal.json';
import itLegalMentions from '../locales/it/legalMentions.json';
import itLogin from '../locales/it/login.json';
import itMarketing from '../locales/it/marketing.json';
import itMarketingTools from '../locales/it/marketingTools.json';
import itMessaging from '../locales/it/messaging.json';
import itNavigation from '../locales/it/navigation.json';
import itNotes from '../locales/it/notes.json';
import itPackages from '../locales/it/packages.json';
import itPlanning from '../locales/it/planning.json';
import itProfile from '../locales/it/profile.json';
import itQuotes from '../locales/it/quotes.json';
import itRegistration from '../locales/it/registration.json';
import itReservations from '../locales/it/reservations.json';
import itServices from '../locales/it/services.json';
import itSettings from '../locales/it/settings.json';
import itSidebar from '../locales/it/sidebar.json';
import itStatistics from '../locales/it/statistics.json';
import itSubscription from '../locales/it/subscription.json';
import itWhatsNew from '../locales/it/whatsNew.json';
import nlAccounting from '../locales/nl/accounting.json';
import nlAccueil from '../locales/nl/accueil.json';
import nlAssociation from '../locales/nl/association.json';
import nlBilling from '../locales/nl/billing.json';
import nlBoarding from '../locales/nl/boarding.json';
import nlCalendar from '../locales/nl/calendar.json';
import nlClientsDogs from '../locales/nl/clientsdogs.json';
import nlCommon from '../locales/nl/common.json';
import nlEvents from '../locales/nl/events.json';
import nlLegal from '../locales/nl/legal.json';
import nlLegalMentions from '../locales/nl/legalMentions.json';
import nlLogin from '../locales/nl/login.json';
import nlMarketing from '../locales/nl/marketing.json';
import nlMarketingTools from '../locales/nl/marketingTools.json';
import nlMessaging from '../locales/nl/messaging.json';
import nlNavigation from '../locales/nl/navigation.json';
import nlNotes from '../locales/nl/notes.json';
import nlPackages from '../locales/nl/packages.json';
import nlPlanning from '../locales/nl/planning.json';
import nlProfile from '../locales/nl/profile.json';
import nlQuotes from '../locales/nl/quotes.json';
import nlRegistration from '../locales/nl/registration.json';
import nlReservations from '../locales/nl/reservations.json';
import nlServices from '../locales/nl/services.json';
import nlSettings from '../locales/nl/settings.json';
import nlSidebar from '../locales/nl/sidebar.json';
import nlStatistics from '../locales/nl/statistics.json';
import nlSubscription from '../locales/nl/subscription.json';
import nlWhatsNew from '../locales/nl/whatsNew.json';

export const AVAILABLE_LANGUAGES = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'nl-BE', name: 'Nederlands (België)', flag: '🇧🇪' },
    { code: 'nl-NL', name: 'Nederlands (Nederland)', flag: '🇳🇱' },
] as const;

export type LanguageCode = typeof AVAILABLE_LANGUAGES[number]['code'];

const resources = {
    en: {
        acaced: enAcaced,
        accounting: enAccounting,
        accueil: enAccueil,
        association: enAssociation,
        billing: enBilling,
        boarding: enBoarding,
        calendar: enCalendar,
        clientsdogs: enClientsDogs,
        common: enCommon,
        events: enEvents,
        legal: enLegal,
        legalMentions: enLegalMentions,
        login: enLogin,
        marketing: enMarketing,
        marketingTools: enMarketingTools,
        messaging: enMessaging,
        navigation: enNavigation,
        notes: enNotes,
        packages: enPackages,
        planning: enPlanning,
        profile: enProfile,
        quotes: enQuotes,
        registration: enRegistration,
        reservations: enReservations,
        services: enServices,
        settings: enSettings,
        sidebar: enSidebar,
        statistics: enStatistics,
        subscription: enSubscription,
        whatsNew: enWhatsNew,
    },
    fr: {
        acaced: frAcaced,
        accounting: frAccounting,
        accueil: frAccueil,
        association: frAssociation,
        billing: frBilling,
        boarding: frBoarding,
        calendar: frCalendar,
        clientsdogs: frClientsDogs,
        common: frCommon,
        events: frEvents,
        legal: frLegal,
        legalMentions: frLegalMentions,
        login: frLogin,
        marketing: frMarketing,
        marketingTools: frMarketingTools,
        messaging: frMessaging,
        navigation: frNavigation,
        notes: frNotes,
        packages: frPackages,
        planning: frPlanning,
        profile: frProfile,
        quotes: frQuotes,
        registration: frRegistration,
        reservations: frReservations,
        services: frServices,
        settings: frSettings,
        sidebar: frSidebar,
        statistics: frStatistics,
        subscription: frSubscription,
        whatsNew: frWhatsNew,
    },
    es: {
        acaced: esAcaced,
        accounting: esAccounting,
        accueil: esAccueil,
        association: esAssociation,
        billing: esBilling,
        boarding: esBoarding,
        calendar: esCalendar,
        clientsdogs: esClientsDogs,
        common: esCommon,
        events: esEvents,
        legal: esLegal,
        legalMentions: esLegalMentions,
        login: esLogin,
        marketing: esMarketing,
        marketingTools: esMarketingTools,
        messaging: esMessaging,
        navigation: esNavigation,
        notes: esNotes,
        packages: esPackages,
        planning: esPlanning,
        profile: esProfile,
        quotes: esQuotes,
        registration: esRegistration,
        reservations: esReservations,
        services: esServices,
        settings: esSettings,
        sidebar: esSidebar,
        statistics: esStatistics,
        subscription: esSubscription,
        whatsNew: esWhatsNew,
    },
    de: {
        acaced: deAcaced,
        accounting: deAccounting,
        accueil: deAccueil,
        association: deAssociation,
        billing: deBilling,
        boarding: deBoarding,
        calendar: deCalendar,
        clientsdogs: deClientsDogs,
        common: deCommon,
        events: deEvents,
        legal: deLegal,
        legalMentions: deLegalMentions,
        login: deLogin,
        marketing: deMarketing,
        marketingTools: deMarketingTools,
        messaging: deMessaging,
        navigation: deNavigation,
        notes: deNotes,
        packages: dePackages,
        planning: dePlanning,
        profile: deProfile,
        quotes: deQuotes,
        registration: deRegistration,
        reservations: deReservations,
        services: deServices,
        settings: deSettings,
        sidebar: deSidebar,
        statistics: deStatistics,
        subscription: deSubscription,
        whatsNew: deWhatsNew,
    },
    it: {
        acaced: itAcaced,
        accounting: itAccounting,
        accueil: itAccueil,
        association: itAssociation,
        billing: itBilling,
        boarding: itBoarding,
        calendar: itCalendar,
        clientsdogs: itClientsDogs,
        common: itCommon,
        events: itEvents,
        legal: itLegal,
        legalMentions: itLegalMentions,
        login: itLogin,
        marketing: itMarketing,
        marketingTools: itMarketingTools,
        messaging: itMessaging,
        navigation: itNavigation,
        notes: itNotes,
        packages: itPackages,
        planning: itPlanning,
        profile: itProfile,
        quotes: itQuotes,
        registration: itRegistration,
        reservations: itReservations,
        services: itServices,
        settings: itSettings,
        sidebar: itSidebar,
        statistics: itStatistics,
        subscription: itSubscription,
        whatsNew: itWhatsNew,
    },
    'nl-BE': {
        accounting: nlAccounting,
        accueil: nlAccueil,
        association: nlAssociation,
        billing: nlBilling,
        boarding: nlBoarding,
        calendar: nlCalendar,
        clientsdogs: nlClientsDogs,
        common: nlCommon,
        events: nlEvents,
        legal: nlLegal,
        legalMentions: nlLegalMentions,
        login: nlLogin,
        marketing: nlMarketing,
        marketingTools: nlMarketingTools,
        messaging: nlMessaging,
        navigation: nlNavigation,
        notes: nlNotes,
        packages: nlPackages,
        planning: nlPlanning,
        profile: nlProfile,
        quotes: nlQuotes,
        registration: nlRegistration,
        reservations: nlReservations,
        services: nlServices,
        settings: nlSettings,
        sidebar: nlSidebar,
        statistics: nlStatistics,
        subscription: nlSubscription,
        whatsNew: nlWhatsNew,
    },
    'nl-NL': {
        accounting: nlAccounting,
        accueil: nlAccueil,
        association: nlAssociation,
        billing: nlBilling,
        boarding: nlBoarding,
        calendar: nlCalendar,
        clientsdogs: nlClientsDogs,
        common: nlCommon,
        events: nlEvents,
        legal: nlLegal,
        legalMentions: nlLegalMentions,
        login: nlLogin,
        marketing: nlMarketing,
        marketingTools: nlMarketingTools,
        messaging: nlMessaging,
        navigation: nlNavigation,
        notes: nlNotes,
        packages: nlPackages,
        planning: nlPlanning,
        profile: nlProfile,
        quotes: nlQuotes,
        registration: nlRegistration,
        reservations: nlReservations,
        services: nlServices,
        settings: nlSettings,
        sidebar: nlSidebar,
        statistics: nlStatistics,
        subscription: nlSubscription,
        whatsNew: nlWhatsNew,
    },
    'nl': {
        accounting: nlAccounting,
        accueil: nlAccueil,
        association: nlAssociation,
        billing: nlBilling,
        boarding: nlBoarding,
        calendar: nlCalendar,
        clientsdogs: nlClientsDogs,
        common: nlCommon,
        events: nlEvents,
        legal: nlLegal,
        legalMentions: nlLegalMentions,
        login: nlLogin,
        marketing: nlMarketing,
        marketingTools: nlMarketingTools,
        messaging: nlMessaging,
        navigation: nlNavigation,
        notes: nlNotes,
        packages: nlPackages,
        planning: nlPlanning,
        profile: nlProfile,
        quotes: nlQuotes,
        registration: nlRegistration,
        reservations: nlReservations,
        services: nlServices,
        settings: nlSettings,
        sidebar: nlSidebar,
        statistics: nlStatistics,
        subscription: nlSubscription,
        whatsNew: nlWhatsNew,
    },
};

migrateToFrenchDefault();

/** #1452 — ?lang= > preferredLanguage > navigator > fallback fr (plus de lng hardcodé). */
const detectionOptions = {
    order: ['querystring', 'localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupLocalStorage: 'preferredLanguage',
    lookupQuerystring: 'lang',
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'fr',
        supportedLngs: ['en', 'fr', 'es', 'de', 'it', 'nl-BE', 'nl-NL', 'nl'],
        nonExplicitSupportedLngs: true,
        load: 'currentOnly',
        defaultNS: 'common',
        ns: ['acaced', 'accounting', 'accueil', 'association', 'billing', 'boarding', 'calendar', 'clientsdogs', 'common', 'events', 'legal', 'legalMentions', 'login', 'marketing', 'marketingTools', 'messaging', 'navigation', 'notes', 'packages', 'planning', 'profile', 'quotes', 'registration', 'reservations', 'services', 'settings', 'sidebar', 'statistics', 'subscription', 'whatsNew'],

        detection: detectionOptions,

        interpolation: {
            escapeValue: false,
        },

        react: {
            useSuspense: true,
        },

        debug: process.env.NODE_ENV === 'development',
    });

export default i18n;
